"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotificationLimit = exports.mapValidationErrors = exports.hasInvalidTelephone = exports.hasInvalidLength = exports.hasInvalidValue = exports.isEmailOrEmpty = exports.isEmail = exports.emailRegExp = exports.hasSafeText = exports.isUnique = exports.isNotNaN = exports.isNotNull = exports.isNotEmptyList = exports.isNotUndefined = exports.isNotFalse = exports.isNotEmpty = exports.ap = exports.successValidation = exports.success = void 0;
/* tslint:disable:no-unnecessary-type-assertion */
const fp = require("fp-ts");
const translation_1 = require("./translation");
exports.success = true;
const A = fp.validation.getApplicative(fp.semigroup.getArraySemigroup());
exports.successValidation = fp.validation.success(exports.success);
const ap = (x) => (y) => A.ap(x.map(() => () => true), y);
exports.ap = ap;
const isNotEmpty = (prop, customKey) => (form) => !!form[prop] && form[prop].toString().trim().length > 0
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: customKey || prop,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotEmpty = isNotEmpty;
const isNotFalse = (prop) => (form) => !!form[prop] && form[prop] !== false
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: prop,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotFalse = isNotFalse;
const isNotUndefined = (key) => (value) => typeof value !== 'undefined'
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotUndefined = isNotUndefined;
const isNotEmptyList = (key) => (value) => typeof value !== 'undefined' && value.length > 0
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotEmptyList = isNotEmptyList;
const isNotNull = (key) => (value) => value !== null
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotNull = isNotNull;
const isNotNaN = (key) => (value) => value !== null && !isNaN(value)
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustNotBeEmpty')
        }
    ]);
exports.isNotNaN = isNotNaN;
const isUnique = (key) => (cond) => cond === true
    ? fp.validation.success(cond)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldMustBeUnique')
        }
    ]);
exports.isUnique = isUnique;
// https://github.com/parshap/node-sanitize-filename/blob/master/index.js
const hasSafeText = (key) => (value) => {
    const illegalRe = /[\/\?<>\\:\*\|":]/g;
    const controlRe = /[\x00-\x1f\x80-\x9f]/g;
    const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
    if (value) {
        const illegal = illegalRe.test(value);
        const control = controlRe.test(value);
        const windowsReserved = windowsReservedRe.test(value);
        if (illegal) {
            return fp.validation.failure([
                {
                    key: key,
                    value: `${(0, translation_1.getLocalization)('validation/error/noIllegalCharacters')} (/\\?<>:*|")`
                }
            ]);
        }
        if (control || windowsReserved) {
            return fp.validation.failure([
                {
                    key: key,
                    value: (0, translation_1.getLocalization)('validation/error/textContainsIllegalCharacters')
                }
            ]);
        }
    }
    return fp.validation.success(exports.success);
};
exports.hasSafeText = hasSafeText;
exports.emailRegExp = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
const validateEmailFormat = (key, value) => exports.emailRegExp.test(value) === true
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/invalidEmailAddres')
        }
    ]);
const emailCharactersRegExp = /^([a-zA-Z0-9!#$%&'*+-/=?^_`{|}~\\\(\)\[\];:<>\.@" ]+)$/;
const validateEmailCharacters = (key, value) => emailCharactersRegExp.test(value) === true
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/emailIllegalCharacters', [
                `a-zA-Z0-9!#$%&'*+-/=?^_\`{|}~.`
            ])
        }
    ]);
const isEmail = (key) => (value) => value
    ? (0, exports.ap)(validateEmailCharacters(key, value))(validateEmailFormat(key, value))
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/invalidEmailAddres')
        }
    ]);
exports.isEmail = isEmail;
const isEmailOrEmpty = (key) => (value) => !value || (0, exports.isEmail)(key)(value);
exports.isEmailOrEmpty = isEmailOrEmpty;
const hasInvalidValue = (key, invalidValues) => (value) => value && !invalidValues.includes(value)
    ? fp.validation.success(exports.success)
    : fp.validation.failure([
        {
            key: key,
            value: (0, translation_1.getLocalization)('validation/error/fieldHasInvalidValue')
        }
    ]);
exports.hasInvalidValue = hasInvalidValue;
const hasInvalidLength = (key, min, max) => (value) => {
    if (value) {
        const minLength = min ? value.length > min : null;
        const maxLength = max ? value.length < max : null;
        if (!maxLength && maxLength !== null) {
            return maxLength
                ? fp.validation.success(exports.success)
                : fp.validation.failure([
                    {
                        key: key,
                        value: (0, translation_1.getLocalization)('validation/error/fieldHasInvalidLength')
                    }
                ]);
        }
        if (!minLength && minLength !== null) {
            return minLength
                ? fp.validation.success(exports.success)
                : fp.validation.failure([
                    {
                        key: key,
                        value: (0, translation_1.getLocalization)('validation/error/fieldHasInvalidLengthTooSmall')
                    }
                ]);
        }
    }
    return fp.validation.success(exports.success);
};
exports.hasInvalidLength = hasInvalidLength;
const validChars = /^[0-9+\-() ]+$/;
const hasInvalidTelephone = (key) => (value) => {
    const numLength = value && value.replace(/\D/g, '');
    return !value ||
        (value &&
            validChars.test(value) === true &&
            numLength &&
            numLength.length > 5)
        ? fp.validation.success(exports.success)
        : fp.validation.failure([
            {
                key: key,
                value: (0, translation_1.getLocalization)('validation/error/invalidTelephone')
            }
        ]);
};
exports.hasInvalidTelephone = hasInvalidTelephone;
const mapValidationErrors = (validationErrors) => validationErrors.reduce((acc, error) => {
    var _a;
    return (Object.assign(Object.assign({}, acc), { [error.key]: [...((_a = acc[error.key]) !== null && _a !== void 0 ? _a : []), error.value] }));
}, {});
exports.mapValidationErrors = mapValidationErrors;
const isNotificationLimit = (notifierList, limit) => notifierList.length > limit
    ? fp.validation.failure([
        {
            key: 'notifyFollowing',
            value: (0, translation_1.getLocalization)('validation/error/tooManyEmails')
        }
    ])
    : fp.validation.success(exports.success);
exports.isNotificationLimit = isNotificationLimit;
//# sourceMappingURL=validation.js.map